
import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"
import { format } from "date-fns"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Format a date to a string in the format "Month Day, Year" (e.g. "January 1, 2021")
 */
export function formatDate(date: Date): string {
  return format(date, "MMMM d, yyyy")
}

/**
 * Format a time to a string in the format "h:mm a" (e.g. "1:30 PM")
 */
export function formatTime(date: Date): string {
  return format(date, "h:mm a")
}
